import { Pipe } from '@angular/core';
import * as i0 from "@angular/core";
export class CheckIfPermissionMissing {
  transform(permissions, permissionToCheck) {
    return !(permissions.length > 0 && permissions.includes(permissionToCheck));
  }
  static ɵfac = function CheckIfPermissionMissing_Factory(t) {
    return new (t || CheckIfPermissionMissing)();
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "checkIfPermissionMissing",
    type: CheckIfPermissionMissing,
    pure: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckIfPermissionMissing, [{
    type: Pipe,
    args: [{
      name: 'checkIfPermissionMissing'
    }]
  }], null, null);
})();
